import React, { useState, useEffect, useContext } from 'react';
import styles from './ZavrsniRadExpanded.module.css';
import Breadcrumb from './Breadcrumb';
import { STATUS_ZAVRSNI_RAD_CUSTOM, BASE_URL_ZAVRSNI_RADOVI } from '../util/constants';
import { ThemeContext } from '../contexts/ThemeContext';

const ZavrsniRadExpanded = (props) => {
  const [breadcrumbPath, setBreadcrumbPath] = useState(['Početna', 'Završni radovi']);

  const [rad, setRad] = useState();
  const { dark } = useContext(ThemeContext);

  useEffect(() => {
    let fetchParams = {
      "where": [{ "operator": "equal", "field": "id", "value": props.match.params.radId }],
      "orderBy": [],
      "fetchSize": 1,
      "fetchOffset": 0
    };
    let fetchParamsEncoded = encodeURI(encodeURI(JSON.stringify(fetchParams)));

    fetch(BASE_URL_ZAVRSNI_RADOVI + "?filter=" + fetchParamsEncoded)
      .then(response => response.json())
      .then(rad => {
        setRad(rad.content[0]);
        setBreadcrumbPath(b => [...b, rad.content[0].tema]);
      })
      .catch(function (err) {
        console.log('Fetch Error :', err);
      });
  }, [props.match.params.radId]);

  return (
    <>
      {rad === undefined || rad === null ? (
        // {/*<div className={styles.emptyListContainer}>Nepostojeci oglas.</div>*/}
        null
      ) : (
          <>
            <Breadcrumb path={breadcrumbPath} />
            <div className={styles.zavrsniRadExpandedContent}>
              <div className={styles.zavrsniRad}>
                <div className={styles.zavrsniRadHeader}>
                  <div className={dark ? styles.zavrsniRadHeadingDark : styles.zavrsniRadHeadingLight}>
                    {rad.tema}
                  </div>
                  <div className={styles.zavrsniRadStatus}>{"Status rada: " + STATUS_ZAVRSNI_RAD_CUSTOM[rad.trenutniStatus.statusZavrsnogRada.id]}</div>
                </div>
                <div className={styles.zavrsniRadBody}>{rad.obrazlozenje}</div>
                <div className={dark ? styles.zavrsniRadStatusFooterDark : styles.zavrsniRadStatusFooterLight}>
                  <div className={styles.statusItem}>{"Predsjednik komisije: " + rad.predsjednikKomisije.ime}</div>
                  <div className={styles.statusItem}>{"Mentor: " + rad.mentor.ime}</div>
                  <div className={styles.statusItem}>{"Član komisije: " + rad.clanKomisije.ime}</div>
                  <div className={styles.statusItem}>{rad.studentIme ? "Student: " + rad.studentIme : null}</div>
                </div>
              </div>
            </div>
          </>
        )}

    </>
  );
}

export default ZavrsniRadExpanded;